var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimeClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_64_5631)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2.53488C6.77256 2.53488 2.53488 6.77256 2.53488 12C2.53488 17.2274 6.77256 21.4651 12 21.4651C17.2274 21.4651 21.4651 17.2274 21.4651 12C21.4651 6.77256 17.2274 2.53488 12 2.53488ZM1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12ZM12 7.13953C12.4238 7.13953 12.7674 7.48313 12.7674 7.90698V11.6821L15.1008 14.0155C15.4005 14.3152 15.4005 14.8011 15.1008 15.1008C14.8011 15.4005 14.3152 15.4005 14.0155 15.1008L11.4573 12.5427C11.3134 12.3987 11.2326 12.2035 11.2326 12V7.90698C11.2326 7.48313 11.5762 7.13953 12 7.13953Z",
    fill: "#1C274C",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_64_5631"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeClock);
export default __webpack_public_path__ + "static/media/time_clock.7a1b13ed560330d42f2a41b8c3fe78fa.svg";
export { ForwardRef as ReactComponent };